<template>
    <div>
        <v-calendar :attributes="events"></v-calendar>

        <v-btn @click="openModal">abrir</v-btn>

        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Crear Reunión</span>
                </v-card-title>
                <v-card-text>
                    <v-form @submit.prevent="createMeeting">
                        <v-text-field v-model="form.title" label="Título"></v-text-field>
                        <v-text-field v-model="form.description" label="Descripción"></v-text-field>
                        <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false"
                            transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="form.start_time" label="Fecha de Inicio"
                                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="form.start_time" @input="startMenu = false"></v-date-picker>
                        </v-menu>
                        <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false"
                            transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="form.end_time" label="Fecha de Fin" prepend-icon="mdi-calendar"
                                    readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="form.end_time" @input="endMenu = false"></v-date-picker>
                        </v-menu>
                        <v-select v-model="form.recurrence_pattern" :items="recurrenceOptions"
                            label="Recurrencia"></v-select>
                        <v-btn type="submit" color="primary">Crear</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            startMenu: false,
            endMenu: false,
            form: {
                title: '',
                description: '',
                start_time: '',
                end_time: '',
                recurrence_pattern: ''
            },
            recurrenceOptions: ['No recurrente', 'Diaria', 'Semanal', 'Mensual'],
            events: []
        };
    },
    methods: {
        openModal(day) {
            //this.form.start_time = day.date;
            this.dialog = true;
        },
        createMeeting() {
            const newEvent = {
                start: this.form.start_time,
                end: this.form.end_time,
                title: this.form.title
            };
            this.events.push(newEvent);

            if (this.form.recurrence_pattern === 'Diaria') {
                for (let i = 1; i <= 30; i++) {
                    const recurringEvent = { ...newEvent };
                    recurringEvent.start = new Date(new Date(this.form.start_time).setDate(new Date(this.form.start_time).getDate() + i));
                    recurringEvent.end = new Date(new Date(this.form.end_time).setDate(new Date(this.form.end_time).getDate() + i));
                    this.events.push(recurringEvent);
                }
            }

            this.dialog = false;
        }
    }
};
</script>

<style>
/* Añade estilos personalizados si es necesario */
</style>